import { render, staticRenderFns } from "./GoodsFinish.vue?vue&type=template&id=4018967e&scoped=true&"
import script from "./GoodsFinish.vue?vue&type=script&lang=js&"
export * from "./GoodsFinish.vue?vue&type=script&lang=js&"
import style0 from "./GoodsFinish.vue?vue&type=style&index=0&id=4018967e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4018967e",
  null
  
)

export default component.exports